export default __webpack_public_path__ + "guide--raster-naip-in-studio-960-c7c44be16b89f4ad63fd7729d9fe609e.webp";